import React, { useState } from 'react';
import css from './SeoPage.module.css';
import IconCard from '../../components/IconCard/IconCard';

const FaqSection = props => {
  const { title, questions } = props;
  const [show, setShow] = useState(null);

  const toggleVisibility = index => {
    setShow(show === index ? null : index);
  };

  return (
    <section className={css.faqSectionWrapper}>
      <div className={css.faqTitle}>{title}</div>
      <div className={css.faqAccordion}>
        {Array.isArray(questions)
          ? questions.map((question, index) => (
              <div key={question.id} className={css.accordionCard}>
                <h3 className={css.accordionHead} onClick={() => toggleVisibility(index)}>
                  {question.question}
                  {show === index ? <IconCard brand="uparrow" /> : <IconCard brand="downarrow" />}
                </h3>
                {show === index && question.answer ? (
                  <div className={css.accordionDescriptionBox}>
                    {Array.isArray(question.answer) ? (
                      question.answer.map((ans, idx) => (
                        <div key={ans.id || idx}>
                          {ans?.children?.map((child, childIdx) => (
                            <p key={childIdx} className={css.faqAnswer}>
                              {child?.text}
                            </p>
                          ))}
                        </div>
                      ))
                    ) : (
                      <p className={css.faqAnswer}>{question.answer}</p>
                    )}
                  </div>
                ) : null}
              </div>
            ))
          : null}
      </div>
    </section>
  );
};

export default FaqSection;
